import { useMemo } from 'react';
import { usePermissions } from 'react-admin';
import { useSelector } from 'react-redux';
import { CustomReducerState } from '../redux/reducers';
import { getRolesFromTokenData } from '../utils/token';

/**
 * Roles from the JWT stored in Redux (updated on tokenFound) take precedence over
 * react-admin's async usePermissions cache, which can be stale right after login.
 */
export const useRolePermissions = () => {
    const tokenData = useSelector((state: CustomReducerState) => state.rikutec.users.tokenData);
    const { permissions: raPermissions, loading, loaded } = usePermissions();

    const permissions = useMemo(() => {
        const rolesFromToken = getRolesFromTokenData(tokenData);
        if (rolesFromToken.length > 0) {
            return rolesFromToken;
        }

        return raPermissions || [];
    }, [tokenData, raPermissions]);

    return { permissions, loading, loaded };
};
